<template>
    <v-breadcrumbs :key="'breadcrumbs-'+key" :items="items">
        <template slot="item" slot-scope="props">
            <router-link
                    :to="props.item.to"
                    :class="{'v-breadcrumbs__item--disabled': props.item.disabled}"
                    class="v-breadcrumbs__item"
            >{{ props.item.name ? $t(props.item.name) : props.item.customName }}</router-link>
        </template>
    </v-breadcrumbs>
</template>

<script>
export default {
    data() {
        return {
            items: [],
            params: [],
            key: 1,
        };
    },
    computed: {
        stateParams() {
            return this.$store.getters.breadcrumbs;
        }
    },
    watch: {
        $route() {
            this.params = [];
            this.generateItems();
        },
        stateParams(params) {
            this.params = params;
            this.reRender();
        }
    },
    methods: {
        generateItems() {

            this.$router.options.routes.forEach(item => {

                if (item.name !== this.$route.name) {
                    return;
                }

                if (typeof item.breadcrumbs === 'object') {
                    this.items = item.breadcrumbs;
                }
            });

            this.reRender();
        },
        reRender() {

            if (typeof this.params !== 'object') {
                return;
            }

            this.params.forEach((param) => {

                if (param.name) {
                    this.items[param.id].customName = param.name;
                }

                if (param.to) {
                    if (param.to.name) {
                        this.items[param.id].to.name = param.to.name;
                    }
                    if (param.to.params) {
                        this.items[param.id].to.params = param.to.params;
                    }
                    if (param.to.query) {
                        this.items[param.id].to.query = param.to.query;
                    }
                }
            });

            this.key++;

            this.setTitle();
        },
        setTitle() {
            let title = '';
            this.items.forEach((item) => {
                let t = '';

                if (title === '') t = title;
                else t = ' | ' + title;

                if (item.customName == null) {
                    title = this.$t(item.name) + t;
                } else {
                    title = item.customName + t;
                }
            });

            document.title = title
        }
    },
    created() {
        this.generateItems();
    },
}
</script>

<style lang="scss">
.v-breadcrumbs {
    padding: 5px 0 !important;
    font-size: 13px;


    a.v-breadcrumbs__item {
        color: #495057 !important;

        &:hover {
            text-decoration: underline;
        }
    }
    a.v-breadcrumbs__item--disabled {
        color: #89949b !important;
    }
}
</style>